import { useId as _, useRef as b, useState as A, useCallback as $, useEffect as H } from "react";
const te = ({
  id: p,
  options: m,
  listboxLabel: O,
  selectedOption: r,
  negative: K,
  disabled: v = !1,
  readOnly: h = !1,
  openOnFocus: S = !1,
  listboxMaxHeight: u,
  highlightFirstOption: y = !1,
  onSelect: T,
  closeOnSelect: P = !0,
  noOptionsText: M,
  ["data-testid"]: w
}) => {
  const N = _(), l = b(null), x = b(null), d = b(null), g = b({}), [k, I] = A(!1), [n, a] = A(
    y ? m[0] : void 0
  ), C = `${p}-listbox`, Y = `${p}-input`, E = (e) => `${p}-listbox-item-${e.id}`, R = `--purpur-autocomplete-${N.replace(/:/g, "")}`, q = { anchorName: R }, B = (e) => w ? `${w}-${e}` : void 0, o = $(() => {
    I(!1), a(void 0);
  }, []);
  H(() => {
    const e = (t) => {
      l.current && !l.current.contains(t.target) && !d.current?.contains(t.target) && o();
    };
    return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
  }, [o]);
  const f = ({ eventType: e }) => {
    I(!0), r && requestAnimationFrame(() => {
      a({ ...r, isSetByClickEvent: e === "CLICK" }), D(g.current[r.id]);
    });
  }, D = (e) => {
    if (!e) return;
    const t = e.getBoundingClientRect(), s = d.current?.getBoundingClientRect() ?? { top: 0, bottom: 0 };
    (t.top < s.top || t.bottom > s.bottom) && e.scrollIntoView({ block: "nearest" });
  }, c = k && (m.length > 0 || !!M), F = (e) => {
    const t = m.filter((i) => !i.disabled);
    if (!t.length) return;
    const s = n ? t.findIndex((i) => i.id === n.id) : -1;
    return e === "ArrowDown" ? t[(s + 1) % t.length] : t[(s - 1 + t.length) % t.length];
  }, U = (e) => {
    c || f({ eventType: "KEYBOARD" });
    const t = F(e);
    a(t ? { ...t } : void 0), t && D(g.current[t.id]);
  }, L = (e) => {
    e.disabled || (T?.(e), x.current?.focus(), P && o());
  }, V = () => {
    f({ eventType: "KEYBOARD" });
  }, j = (e) => {
    if (!(v || h))
      switch (e.key) {
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault(), U(e.key);
          break;
        case "Enter":
          c && n && (e.preventDefault(), L(n));
          break;
        case "Escape":
          e.preventDefault(), o();
          break;
        case "Tab":
          o();
          break;
      }
  }, z = () => {
    !k && S && !v && !h && f({ eventType: "KEYBOARD" });
  }, G = () => {
    setTimeout(() => {
      const e = document.activeElement;
      e !== document.body && !x.current?.contains(e) && !d.current?.contains(e) && !l.current?.contains(e) && o();
    });
  }, J = () => {
    v || h || (c ? o() : f({ eventType: "CLICK" }));
  }, Q = $((e) => {
    if (d.current = e, e && typeof e.showPopover == "function")
      try {
        e.showPopover();
      } catch {
      }
  }, []), W = {
    "aria-label": O,
    "aria-expanded": c,
    "data-testid": B("listbox"),
    id: C,
    ref: Q,
    onMouseLeave: () => a(void 0),
    popover: "manual",
    negative: K,
    style: {
      ...u ? {
        maxHeight: typeof u == "number" ? `${u}px` : u
      } : {},
      positionAnchor: R
    }
  }, X = (e, t) => {
    const s = (e.id === n?.id || y && !n && t === 0) && !n?.isSetByClickEvent;
    return {
      "data-testid": B(`listbox-item-${e.id}`),
      id: E(e),
      key: e.id,
      onMouseMove: () => {
        e.id !== n?.id && a({ ...e, isSetByClickEvent: !0 });
      },
      onMouseUp: () => L(e),
      ref: (i) => {
        i && (g.current[e.id] = i);
      },
      tabIndex: -1,
      selected: e.id === r?.id,
      disabled: e.disabled,
      highlighted: s,
      hovered: e.id === n?.id && !!n?.isSetByClickEvent,
      "aria-selected": e.id === r?.id
    };
  }, Z = {
    role: "combobox",
    "aria-autocomplete": "list",
    "aria-expanded": c,
    "aria-controls": C,
    "aria-activedescendant": n ? E(n) : void 0,
    autoComplete: "off",
    onKeyDown: j,
    onFocus: z,
    onBlur: G,
    onMouseDown: J
  };
  return {
    rootRef: l,
    inputRef: x,
    inputId: Y,
    inputProps: Z,
    listboxProps: W,
    getListboxItemProps: X,
    isOpen: c,
    openListbox: V,
    anchorStyle: q
  };
};
export {
  te as useAutocomplete
};
//# sourceMappingURL=use-autocomplete.es.js.map
